import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import pulsar180 from "../../images/pulsar-180.jpg";
import "../../../src/product.css";

const Pulsar180 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">PULSAR 180cc</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={pulsar180}
              alt="Bajaj Pulsar 180cc"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Pulsar 180 has been designed to surge ahead while proving its
              technological acumen. A renowned bike that has been a part of
              the Pulsar stable since its inception in 2001. It has been
              consistently winning immense appreciation for its solid,
              muscular looks and power packed performance.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>178 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>147 kg</strong>
            </div>

            <div className="spec-card">
              <span>Max Speed</span>
              <strong>122 Kmph</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Pulsar180;